
import { UnitedOne as uo } from './Utils';
import { UnitedOne as services } from './Services';

var tsRefactoring = true;

declare var UnitedOne, WebmasterTools, Highcharts, kendo, ko;


class HighchartsConfig {

    public configure() {
       
        if (typeof Highcharts != 'undefined') {
            Highcharts.setOptions({
                global: {
                    useUTC: false
                },
                lang: {
                    decimalPoint: ',',
                    thousandsSep: '.',
                    loading: 'Daten werden geladen...',
                    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                    weekdays: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                    shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                    exportButtonTitle: "Exportieren",
                    printButtonTitle: "Drucken",
                    rangeSelectorFrom: "Von",
                    rangeSelectorTo: "Bis",
                    rangeSelectorZoom: "Zeitraum",
                    downloadPNG: 'Download als PNG-Bild',
                    downloadJPEG: 'Download als JPEG-Bild',
                    downloadPDF: 'Download als PDF-Dokument',
                    downloadSVG: 'Download als SVG-Bild',
                    resetZoom: "Zoom zurücksetzen",
                    resetZoomTitle: "Zoom zurücksetzen"
                },
                colors: jsData.generals.companyInformations.chartColors
                //colors: ["#0070CC", "#F90101", "#F2B50F", "#00933B"]
            });
        }

    }
} 
uo.Utils.registerDocumentReady(() => new HighchartsConfig().configure());

class KendoConfig {

    public configure() {

        kendo.culture("de-DE");

        kendo.ui.DatePicker.fn.options.format = 'dd.MM.yyyy';

        kendo.ui.TimePicker.fn.options.format = 'hh:mm';

        if (kendo.ui.NumericTextBox)
        {
            kendo.ui.NumericTextBox.prototype.options =
                $.extend(true, kendo.ui.NumericTextBox.prototype.options, {
                    "upArrowText": "Wert erhöhen",
                    "downArrowText": "Wert verringern"
                });
        }

       
    }
}
uo.Utils.registerDocumentReady(() => new KendoConfig().configure());

class KnockoutConfig {

    public configure() {
        ko.validation.init({
            insertMessages: true,
            errorElementClass: 'data-validation-error',
            decorateElement: true,
            parseInputAttributes: true,
            messagesOnModified: false,
            errorsAsTitleOnModified: true
        });


        ko.validation.rules['areSame'] = {
            getValue: function (o) {
                return (typeof o === 'function' ? o() : o);
            },
            validator: function (val, otherField) {
                return val === this.getValue(otherField);
            },
            message: 'Die Angaben stimmen nicht überein'
        };

        ko.validation.rules['checked'] = {
            validator: function (value) {
                if (!value) {
                    return false;
                }
                return true;
            }
        };

        ko.validation.rules['domain'] = {
            validator: function (val) {
                if (val == null || val == '')
                    return true;

                var regex = /^[A-Za-z0-9-]*([.]+[A-Za-z0-9-öäüÖÄÜ]+)+$/;
                return regex.test(val);
            },
            message: function () { return 'Es muss eine gültige Domain angegeben werden (z.B. example.com).' }
        };

        ko.validation.rules['domain_http'] = {
            validator: function (val) {
                if (val == null || val == '')
                    return true;
                var regex = /^(https?:\/\/).*$/i;
                return !regex.test(val);
            },
            message: function () { return 'Bitte gib die Domain ohne "http://" ein.' }
        };
    
        ko.validation.rules['iban'] = {
            validator: function (val) {

                return uo.Utils.isValidIban(val);
            },
            message: function () { return 'Das ist keine gültige IBAN-Nummber.' }
        };

        ko.validation.rules['bic'] = {
            validator: function (val) {

                return uo.Utils.isValidBic(val);
            },
            message: function () { return 'Das ist kein gültiger BIC/SWIFT-Code.' }
        };

        ko.validation.rules['url'] = {
            validator: function (val) {
                if (val == null || val == '')
                    return true;

                var regex = /^(http|https):\/\/[^ "]+$/;
                return regex.test(val);
            },
            message: 'Es muss eine gültige URL angegeben werden (z.B. http://example.org).'
        };

        ko.validation.rules['urlNonStrict'] = {
            validator: function (val) {
                if (val == null || val == '')
                    return true;
                var regex = /^(https?:\/\/)?([\da-zöäü\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i;
                return regex.test(val);
            },
            message: 'Es muss eine gültige URL angegeben werden (z.B. http://example.org).'
        };

        ko.validation.rules['passwordStrength'] = {
            validator: function (val) {
                return uo.Utils.checkPasswordStrength(val);
            },
            message: 'Das Passwort muss mindestens 8 Zeichen lang sein und muss einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten. Es darf zusätzlich keine Leerzeichen enthalten.'
        };

        ko.validation.rules['dummy'] = {
            async: false,
            validator: function (val, otherVal, callback) { return true; }
        };
        ko.validation.registerExtenders();


        // ------------------------- Shortcut for Toggle hover-class ------------------------- //
        ko.bindingHandlers.hoverToggle = {
            update: function (element, valueAccessor) {
                var css = valueAccessor();

                ko.utils.registerEventHandler(element, "mouseover", function () {
                    ko.utils.toggleDomNodeCssClass(element, ko.utils.unwrapObservable(css), true);
                });

                ko.utils.registerEventHandler(element, "mouseout", function () {
                    ko.utils.toggleDomNodeCssClass(element, ko.utils.unwrapObservable(css), false);
                });
            }
        };


        ko.bindingHandlers.executeOnEnter = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
                var allBindings = allBindingsAccessor();
                $(element).keypress(function (event) {
                    var keyCode = (event.which ? event.which : event.keyCode);
                    if (keyCode === 13) {
                        allBindings.executeOnEnter.call(viewModel, event);
                        return false;
                    }
                    return true;
                });
            }
        };

        ko.bindingHandlers.clickAndStop = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, context) {
                var handler = ko.utils.unwrapObservable(valueAccessor()),
                    newValueAccessor = function () {
                        return function (data, event) {
                            handler.call(viewModel, data, event);
                            event.cancelBubble = true;
                            if (event.stopPropagation) event.stopPropagation();
                        };
                    };

                ko.bindingHandlers.click.init(element, newValueAccessor, allBindingsAccessor, viewModel, context);
            }
        };

        ko.bindingHandlers.singleOrDoubleClick = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var singleHandler = valueAccessor().click,
                    doubleHandler = valueAccessor().dblclick,
                    delay = valueAccessor().delay || 200,
                    clicks = 0;

                $(element).click(function (event) {
                    clicks++;
                    if (clicks === 1) {
                        setTimeout(function () {
                            if (clicks === 1) {
                                // Call the single click handler - passing viewModel as this 'this' object
                                // you may want to pass 'this' explicitly
                                if (singleHandler !== undefined) {
                                    singleHandler.call(viewModel, bindingContext.$data, event);
                                }
                            } else {
                                // Call the double click handler - passing viewModel as this 'this' object
                                // you may want to pass 'this' explicitly
                                if (doubleHandler !== undefined) {
                                    doubleHandler.call(viewModel, bindingContext.$data, event);
                                }
                            }
                            clicks = 0;
                        }, delay);
                    }
                });
            }
        };

        ko.bindingHandlers.hidden = (function () {
            function setVisibility(element, valueAccessor) {
                var hidden = ko.unwrap(valueAccessor());
                if (hidden) {
                    $(element).css('visibility', 'hidden');
                    $(element).css('height', '0px');
                    $(element).css('overflow', 'hidden');
                }
                else {
                    $(element).css('visibility', 'visible');
                    $(element).css('height', '');
                    $(element).css('overflow', '');
                }


            }
            return { init: setVisibility, update: setVisibility };
        })();

        ko.bindingHandlers.hidden2 = (function () {
            function setVisibility(element, valueAccessor) {
                var hidden = ko.unwrap(valueAccessor());

                if (hidden) {
                    $(element).css('display', 'block');
                    $(element).css('overflow', 'hidden');
                    $(element).css('height', '0px');
                }
                else {
                    $(element).css('height', '');
                }


            }
            return { init: setVisibility, update: setVisibility };
        })();

        ko.bindingHandlers.fadeVisible = {
            init: function (element, valueAccessor) {
                // Initially set the element to be instantly visible/hidden depending on the value
                var value = valueAccessor();
                $(element).toggle(ko.unwrap(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
            },
            update: function (element, valueAccessor) {
                // Whenever the value subsequently changes, slowly fade the element in or out
                var value = valueAccessor();
                ko.unwrap(value) ? $(element).fadeIn() : $(element).fadeOut();
            }
        };

        ko.bindingHandlers.stopBinding = {
            init: function () {
                return { controlsDescendantBindings: true };
            }
        };

        ko.virtualElements.allowedBindings.stopBinding = true;


        ko.bindingHandlers.onLoad = {
            init: function (element, valueAccessor) {
                //Log(valueAccessor());
                var valueUnwrapped = ko.unwrap(valueAccessor());
                valueUnwrapped();

                //$(elem).trigger("create");
            }
        }

        ko.bindingHandlers.inverseChecked = {
            init: function (element, valueAccessor, allBindingsAccessor) {
                var value = valueAccessor();
                var interceptor = ko.computed({
                    read: function () {
                        return !value();
                    },
                    write: function (newValue) {
                        value(!newValue);
                    },
                    disposeWhenNodeIsRemoved: element
                });

                var newValueAccessor = function () { return interceptor; };


                //keep a reference, so we can use in update function
                ko.utils.domData.set(element, "newValueAccessor", newValueAccessor);
                //call the real checked binding's init with the interceptor instead of our real observable
                ko.bindingHandlers.checked.init(element, newValueAccessor, allBindingsAccessor);
            }
        };


        ko.subscribable.fn.subscribeChanged = function (callback) {
            var oldValue;
            this.subscribe(function (_oldValue) {
                oldValue = _oldValue;
            }, this, 'beforeChange');

            this.subscribe(function (newValue) {
                callback(newValue, oldValue);
            });
        };

        
        // Extender for setting
        ko.extenders.setting = function (target, identifier) {
            target(services.Services.getInstance().userprofile.getSetting(identifier, target()));
            target.subscribe(function () { services.Services.getInstance().userprofile.setSetting(identifier, target()); });
            return target;
        };

        ko.extenders.numeric = function (target, precision) {
            //create a writable computed observable to intercept writes to our observable
            var result = ko.pureComputed({
                read: target,  //always return the original observables value
                write: function (newValue) {
                    var current = target(),
                        roundingMultiplier = Math.pow(10, precision),
                        newValueAsNum = isNaN(newValue) ? 0 : +newValue,
                        valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

                    //only write if it changed
                    if (valueToWrite !== current) {
                        target(valueToWrite);
                    } else {
                        //if the rounded value is the same, but a different value was written, force a notification for the current field
                        if (newValue !== current) {
                            target.notifySubscribers(valueToWrite);
                        }
                    }
                }
            }).extend({ notify: 'always' });

            //initialize with current value to make sure it is rounded appropriately
            result(target());

            //return the new computed observable
            return result;
        };

        ko.bindingHandlers.kendoTimePicker.options = {
            format: "HH:mm"
        };


    }
}
uo.Utils.registerDocumentReady(() => new KnockoutConfig().configure());

class DatatableConfig {

    public configure() {
        if (jQuery.fn.dataTable != undefined) {
            (jQuery.fn.dataTable.Api as any).register('processing()', function (show) {
                return this.iterator('table', function (ctx) {
                    ctx.oApi._fnProcessingDisplay(ctx, show);
                });
            });
        }
    }
}
uo.Utils.registerDocumentReady(() => new DatatableConfig().configure());


declare var jsData;

uo.Utils.registerDocumentReady(() => {
    if ((jsData != null) && (jsData.area != null)) {
        if (jsData.area.useSpecialColors) {
            $('body').addClass('special-colors');
        }
    }
});
